import { createContext } from 'react';
import { ErrorValue, errorValueDefault } from '../error-value';

const ErrorContext = createContext<ErrorValue>(errorValueDefault);

export { ErrorContext };
